import { Component, inject, OnInit } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { SkeletonModule } from 'primeng/skeleton'
import { TableModule } from 'primeng/table'
import { finalize } from 'rxjs/operators'

import { EmptyPageComponent } from 'app/_shared/components/empty-page/empty-page.component'
import { GiftCardDto } from 'app/_shared/interfaces/Order'
import { UsdPipe } from 'app/_shared/pipes/currency.pipe'
import { PricePipe } from 'app/_shared/pipes/price.pipe'
import { GiftCardService } from 'app/_shared/services/gift-card.service'
import { ToastService } from 'app/_shared/services/toast.service'
import { AppConfigService } from 'app/app-config.service'
import { GiftCardStore } from 'app/store/gift-card.store'

@Component({
  selector: 'app-gift-cards',
  standalone: true,
  imports: [TableModule, SkeletonModule, TranslatePipe, EmptyPageComponent, PricePipe, UsdPipe],
  templateUrl: './gift-cards.component.html',
  styleUrl: './gift-cards.component.scss'
})
export class GiftCardsComponent implements OnInit {
  private service = inject(GiftCardService)
  private toast = inject(ToastService)
  private giftCardStore = inject(GiftCardStore)
  appConfigService = inject(AppConfigService)

  giftCards: GiftCardDto[] = []
  isLoading = false
  storefrontId = this.appConfigService.getAppConfig?.id

  ngOnInit(): void {
    this.fetchGiftCards()
  }

  private fetchGiftCards(): void {
    this.isLoading = true
    this.service
      .getGiftCards(this.storefrontId!)
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe({
        next: cards => {
          this.giftCards = cards
          // Keep the shared store (and therefore the navbar) in sync with
          // whatever the account page just fetched.
          this.giftCardStore.setAccountCards(cards)
        },
        error: err => this.toast.error(err.error?.message ?? 'Unknown error')
      })
  }
}
